export default __webpack_public_path__ + "static/media/028-tow truck.57450661.svg";